import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { PrivateRoute } from "@/components/auth/PrivateRoute";
import FAQ from "@/pages/FAQ";

export const Route = createFileRoute("/faq")({
  head: () => seoHead({
    title: "Perguntas Frequentes | Shopping do Bem",
    description: "Tire suas dúvidas sobre o Shopping do Bem.",
    path: "/faq", noindex: true,
  }),
  component: () => (
    <PrivateRoute>
      <FAQ />
    </PrivateRoute>
  ),
});
